﻿/* SHALEM — Bloque de compra estilo Spacegoods
   Se carga desde snippets/shalem-whatsapp-flotante.liquid.
   Ajusta el DOM del bloque de compra sin tocar shalem-producto.liquid.
   Necesario porque shalem-scripts.js reescribe el botón con textContent. */
(function () {
  'use strict';

  var GARANTIA = '🛡 Garantía 30 días · Devolución total';

  function texto(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  /* Limpia los ">" sueltos que dejó un HTML mal cerrado */
  function limpiarSueltos(raiz) {
    if (!raiz) return;
    var walker = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var basura = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim() === '>') basura.push(n);
    }
    basura.forEach(function (b) {
      if (b.parentNode) b.parentNode.removeChild(b);
    });
  }

  /* PASO 3 — "Listo para enviar" encima del botón */
  function insertarReadyShip(form) {
    // C3-A — desactivado: esta linea separaba los packs del CTA (71px). El dato ya vive en el microcopy.
    return;
    if (!form || !form.parentNode) return;
    if (document.querySelector('.shalem-ready-ship')) return;
    var div = document.createElement('div');
    div.className = 'shalem-ready-ship';
    div.innerHTML = '<span class="shalem-ready-dot"></span>Listo para enviar — llega en <strong>1-2 días hábiles</strong>';
    form.parentNode.insertBefore(div, form);
  }

  /* PASO 4 — Beneficios bajo el botón */
  function insertarPostCta() {
    // C5 — desactivado: "Recompra / Sin suscripcion" se movio al bloque .shalem-persuasion, fuera del cierre.
    return;
    if (document.querySelector('.shalem-post-cta')) return;
    var micro = document.querySelector('.shalem-prod-microcopy');
    if (!micro || !micro.parentNode) return;
    var div = document.createElement('div');
    div.className = 'shalem-post-cta';
    div.innerHTML = '<span>🔄 Recompra cuando quieras</span>' +
                    '<span class="shalem-post-sep">|</span>' +
                    '<span>✕ Sin suscripción</span>';
    micro.parentNode.insertBefore(div, micro.nextSibling);
  }

  /* PASO 2 — Botón en dos líneas, se repinta cada vez que el
     script del tema lo sobrescribe con textContent */
  function initBoton(btn) {
    if (!btn) return;
    var precioEl = document.querySelector('[data-shalem-precio]');
    var antesEl = document.querySelector('[data-shalem-precio-tachado]');
    var disponible = btn.getAttribute('data-texto-disponible') || 'AGREGAR';
    var etiquetas = ['data-texto-disponible', 'data-texto-agotado', 'data-texto-elige']
      .map(function (attr) { return btn.getAttribute(attr); })
      .filter(function (v) { return !!v; });

    function etiquetaActual() {
      var t = texto(btn);
      return etiquetas.indexOf(t) !== -1 ? t : disponible;
    }

    function pintar() {
      if (btn.querySelector('.shalem-btn-l1')) return;
      var etiqueta = etiquetaActual();
      // C3-C/D — boton de UNA sola linea: sin precio tachado y sin la linea de garantia.
      // Esa informacion ya vive arriba (ancla) y en el microcopy bajo el boton.
      var html = '<span class="shalem-btn-l1">' + etiqueta;
      if (etiqueta === disponible) {
        var p = texto(precioEl);
        if (p) html += ' — <span class="shalem-btn-precio">' + p + '</span>';
      }
      html += '</span>';
      btn.innerHTML = html;
    }

    pintar();
    if (window.MutationObserver) {
      new MutationObserver(pintar).observe(btn, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function init() {
    limpiarSueltos(document.querySelector('.shalem-prod-compra'));
    var wrap = document.querySelector('[data-shalem-producto-form]');
    if (wrap) insertarReadyShip(wrap.querySelector('form'));
    insertarPostCta();
    initBoton(document.querySelector('[data-shalem-submit]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
